<!-- Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved. -->

<div class="outer-wrapper">
  <div class="indirect-login-heading" *ngIf="!(outerBanner | async)"></div>
  <mat-toolbar class="toolbar mat-elevation-z0" *ngIf="outerBanner | async">
    <mat-toolbar-row class="title">
      <div *ngIf="partnerId === cigentPartner || partnerId === digistorPartner || partnerId === doqubizPartner"
           class="img-banner">
        <img class="cigent-logo" src="assets/Cigent_Logo_Light_R.webp" alt="Company Logo" />
        <img class="cigent-box" src="assets/cigent-box.jpg" alt="Generic image" />
      </div>
      <div *ngIf="partnerId === lenovoPartner" class="img-banner">
        <div class="lenovo-logo-wrapper">
          <span class="lenovo-logo"></span>
          <div>
            <span class="data-defense">
              Data Defense <span class="powered-by-cigent">powered by Cigent</span>
            </span>
          </div>
        </div>
        <img class="cigent-box" src="assets/cigent-box.jpg" alt="Company Logo" />
      </div>
      <div *ngIf="partnerId === kanguruPartner" class="img-banner">
        <div class="kanguru-logo-wrapper">
          <span class="kanguru-logo"></span>
          <div>
            <span class="data-defense"><span class="powered-by-cigent">Powered by Cigent</span>
            </span>
          </div>
        </div>
        <img class="cigent-box" src="assets/cigent-box.jpg" alt="Company Logo" />
      </div>
      <div *ngIf="partnerId === vrsPartner" class="img-banner">
        <div class="vrs-logo-wrapper">
          <span class="vrs-logo"></span>
          <div>
            <span class="data-defense"><span class="powered-by-cigent">Powered by Cigent</span>
            </span>
          </div>
        </div>
        <img class="cigent-box" src="assets/cigent-box.jpg" alt="Company Logo" />
      </div>

    </mat-toolbar-row>
  </mat-toolbar>
  <mat-card appearance="raised" class="form-container mat-elevation-z1">
    <mat-card-content>
      <div class="reset-wrapper">
        <h1>{{fHeader}}</h1>
      </div>
      <form *ngIf="!codeVerified; else showPasswordForm" [formGroup]="form">
        <p *ngIf="!showVerifyCode; else checkYourEmail" class="description">{{fSendCode}}</p>
        <ng-template #checkYourEmail>
          <p class="description">{{fIfMail}}</p>
        </ng-template>
        <div class="controls-wrapper">
          <mat-form-field *ngIf="!showVerifyCode" appearance="outline">
            <mat-label>{{fEmail}}</mat-label>
            <input matInput appAutofocus placeholder="{{fEmailAddress}}" formControlName="email" required [value]="email" data-lpignore="true" />
            <mat-error *ngIf="isFieldInvalid('email')">
              {{fInvalidEmail}}
            </mat-error>
          </mat-form-field>

          <div *ngIf="showVerifyCode">
            <mat-form-field appearance="outline">
              <input matInput appAutofocus placeholder="{{fResetCode}}" formControlName="reset_code" required data-lpignore="true" />
              <mat-error *ngIf="isFieldInvalid('reset_code')">
                {{'RP_VERIF_CODE_REQS' | translate}}
              </mat-error>
            </mat-form-field>
            <div class="reset-btn-wrapper">
              <button class="reset-btn" color="primary" mat-flat-button (click)="onVerifyCode()">{{fVerify}}</button>
            </div>
          </div>

          <div *ngIf="showWait">
            <p class="wait">{{fWait}}</p>
            <p class="wait">{{seconds}}</p>
          </div>

          <div *ngIf="!showVerifyCode" class="reset-btn-wrapper">
            <button [disabled]="showWait || (submittingEmail | async)" (click)="onSubmit()" class="reset-btn" color="primary" mat-flat-button>{{fSend}}</button>
          </div>
          <div class="login-link">
            <a routerLink="/login" routerLinkActive="active">{{fPassword}}</a>
          </div>
        </div>
      </form>
      <ng-template #showPasswordForm>

        <app-password
          mode="RESET"
          [showBestPractices]="false"
          [resetCode]="form.value.reset_code"
          [isEmailVerified]="isEmailVerified"
          [email]="form.value.email">
        </app-password>

      </ng-template>
    </mat-card-content>
  </mat-card>
  <div class="footer">
    <div>
      <span *ngIf="partnerId === lenovoPartner; else cigentCopyright">
        <a href="https://www.lenovo.com/privacy" rel="noopener noreferrer" target="_blank">Lenovo Privacy Statement</a>
      </span>
      <ng-template #cigentCopyright>
        <span>&copy; {{ currentYear }} Cigent Technology Inc.</span>
      </ng-template>
    </div>
    <div>{{'ADO_EMAIL' | translate}} <a href="mailto:support@cigent.com" target="_blank" rel="noopener noreferrer">support&#64;cigent.com</a> {{'OR_VISIT_TEXT' | translate}} <a href="https://support.cigent.com/support/home" target="_blank" rel="noopener noreferrer" title="Cigent Support">{{'CIGENT_SUPPORT_LINK_TEXT' | translate}}</a></div>
    <div>
      <span *ngIf="partnerId === lenovoPartner; else cigentTermsAndPolicies">
        <a href="https://www.cigent.com/policies" rel="noopener noreferrer" target="_blank">Cigent Privacy Policies</a>
      </span>
      <ng-template #cigentTermsAndPolicies>
        <span>Cigent's <a href="https://www.cigent.com/terms" rel="noopener noreferrer" target="_blank">{{'SUBF_TERMS' | translate}}</a> {{'SUBF_AND' | translate}} <a href="https://www.cigent.com/policies" rel="noopener noreferrer" target="_blank">{{'DIV_TOUD' | translate}}</a></span>
      </ng-template>
    </div>
  </div>
</div>
